import { MARQUEE_ITEMS } from "@/data/content";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="marquee bg-linen-2 border-y border-line py-5 overflow-hidden" data-testid="suburb-marquee">
      <div className="marquee-track">
        {items.map((s, i) => (
          <span key={i} className="flex items-center gap-8 px-8 font-serif italic text-xl sm:text-2xl text-ink/70 whitespace-nowrap">
            {s} <span className="h-1.5 w-1.5 rounded-full bg-brass inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
};
